module.exports = __webpack_public_path__ + "img/submitProject.72da6065.webp";